'use strict';
/**
 * Dependencies
 */

var _regeneratorRuntime = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var JWK = require('./JWK');
/**
 * JWKSet
 *
 * @class
 * JWKSet represents a JSON Web Key Set as described in Section 5 of RFC 7517:
 * https://tools.ietf.org/html/rfc7517#section-5
 */


var JWKSet = /*#__PURE__*/function () {
  function JWKSet() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        keys = _ref.keys;

    _classCallCheck(this, JWKSet);

    this.keys = keys;
  }
  /**
   * importKeys
   */


  _createClass(JWKSet, null, [{
    key: "importKeys",
    value: function () {
      var _importKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(jwks) {
        var imported, importing;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (jwks.keys) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", Promise.reject(new Error('Cannot import JWKSet: keys property is empty')));

              case 2:
                _context.prev = 2;
                imported = new JWKSet(jwks);
                importing = jwks.keys.map(function (key) {
                  return JWK.importKey(key);
                });
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](2);
                return _context.abrupt("return", Promise.reject(_context.t0));

              case 10:
                return _context.abrupt("return", Promise.all(importing).then(function (keys) {
                  imported.keys = keys;
                  return imported;
                }));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 7]]);
      }));

      function importKeys(_x) {
        return _importKeys.apply(this, arguments);
      }

      return importKeys;
    }()
  }]);

  return JWKSet;
}();
/**
 * Export
 */


module.exports = JWKSet;